import React from 'react';
import styled from 'styled-components';

import pageUpButton from '../assets/pageUp-arrow.svg';

export default function PageUpButton({ onClick }) {
	return (
		<Container className='pageUp-button' onClick={onClick}>
			<img src={pageUpButton} alt='page Up' />
		</Container>
	);
}

const Container = styled.div`
	background-color: var(--button-bg-color);
	width: 100%;
	text-align: center;
	padding: 3rem 0rem;
	display: flex;
	justify-content: center;
	align-items: center;

	@media screen {
	}
	border-radius: 10px;
`;
